import type * as ecModels from '../../../models'

import type { Plugin } from './plugin'

export class Selectors<TTypeParams extends ecModels.TypeParams.Constraint> {
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly statusLookup

  // NOTE: intentionally not typed here so that type can be inferred
  public readonly isLoading

  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getError

  constructor(plugin: Plugin<TTypeParams>) {
    this.statusLookup = plugin.feature.state.project(state => state?.statuses)

    const getEntry = plugin.feature.createSelectorMethod(
      (id: ecModels.EntityId) =>
        this.statusLookup.project(lookup => lookup[id]).asSelector,
    )

    this.isLoading = plugin.feature.createSelectorMethod(
      (id: ecModels.EntityId) =>
        getEntry(id).project(entry => !!entry?.isLoading).asSelector,
    )

    this.getError = plugin.feature.createSelectorMethod(
      (id: ecModels.EntityId) =>
        getEntry(id).project(entry => entry?.error).asSelector,
    )
  }
}
